module.exports = __webpack_public_path__ + "static/media/guest_list.c897914b.svg";